import React, { Fragment } from "react";
import { Table } from "reactstrap";
import "./style.css"; // Importamos el archivo CSS para los estilos

const ExtendedData = ({ person, changedPerson}) => {
  const changedExtendedData = changedPerson.PersonExtendedData.filter(
    (group) => group.Instance && group.Instance.length > 0
  );
  const ExtendedData = person.PersonExtendedData.filter(
    (group) => group.Instance && group.Instance.length > 0
  );

  const renderExtensionGroup = (extensionGroup) => {
    return (
      <tr key={extensionGroup.ExtensionGroupId}>
        <td>{extensionGroup.ExtensionGroupInternal}</td>
        <td>
          {extensionGroup.ExtensionGroupMultipleSelection ? (
            <ul>
              {extensionGroup.Instance.map((instance) => (
                <li key={instance.ExtensionInstanceId}>{getValue(extensionGroup,instance)}</li>
                
              ))}
            </ul>
          ) : (
            getExtensionItemDescription(extensionGroup)
          )}
        </td>
      </tr>
    );
  };

  const getValue = (extensionGroup, instance) => {
    if (extensionGroup.ExtensionGroupType=="freetext"){
      return instance.ExtensionInstanceText;
    }else{
      const item = extensionGroup.Item.find(
        (item) => item.ExtensionItemId === instance.ExtensionItemId
      );
      return item ? item.ExtensionItemDescription : "No item found";
    }
  }

  const getExtensionItemDescription = (extensionGroup) => {
    if(extensionGroup.ExtensionGroupType=="freetext"){
      return extensionGroup.Instance[0].ExtensionInstanceText;
    }
    if (!extensionGroup.Item || extensionGroup.Item.length === 0) {
      return "No item found";
    }
    const item = extensionGroup.Item.find(
      (item) => item.ExtensionItemId === extensionGroup.Instance[0].ExtensionItemId
    );
    return item ? item.ExtensionItemDescription : "No item found";
  };

  return (
    <Fragment>
        <h4>Extended Data</h4>
      <h4>Original</h4>
      <div className="table-container">
        {" "}
        {/* Div contenedor para aplicar estilos */}
        <Table className="table" striped>
          <thead>
            <tr>
              <th>Extension Group</th>
              <th>Data</th>
            </tr>
          </thead>
          <tbody>{ExtendedData.map(renderExtensionGroup)}</tbody>
        </Table>
      </div>

      <h4>Changes requested</h4>
      <div className="table-container">
        {" "}
        {/* Div contenedor para aplicar estilos */}
        <Table className="table" striped>
          <thead>
            <tr>
              <th>Extension Group</th>
              <th>Data</th>
            </tr>
          </thead>
          <tbody>{changedExtendedData.map(renderExtensionGroup)}</tbody>
        </Table>
      </div>
    </Fragment>
  );
};

export default ExtendedData;
